import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import RestlessDisplayProperty from "../../../components/common/RestlessDisplayProperty";
import RestlessDisplayLarge from "../../../components/common/RestlessDisplayLarge";
import axios from "axios";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import { useDispatch } from "react-redux";

export default function PostsDetailsDialog({ row, id, show, onHide }) {
  const [gifUrl, setGifUrl] = useState("");
  const dispatch = useDispatch();

  //GIF FROM GIPHY MANAGMENT
  useEffect(() => {
    const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY;

    if (!row?.gif_id) return;
    axios
      .get(
        `https://api.giphy.com/v1/gifs/${row.gif_id}?api_key=${GIPHY_API_KEY}`
      )
      .then((response) => {
        setGifUrl(response.data.data.images.downsized.url);
      })
      .catch((err) => console.log(err));
  }); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    dispatch(fetchImageToken);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Header>
        <div className="col-6">Posts Details</div>
        <div className="col-6 d-flex justify-content-end">
          Created on April 15th, 2021, 08:55
        </div>
      </Modal.Header>
      <Modal.Body>
        {row && (
          <div className="container">
            <div className="row">
              <div className="col">
                <RestlessDisplayProperty label="ID" content={row.id} />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Type"
                  content={row.poll ? "Poll" : "Text / Media"}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Source"
                  content={
                    (row?.article && "Article") ||
                    (row?.comment && "Comment") ||
                    (row.post && !row.comment && "Post")
                  }
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Author"
                  content={row.restless_user?.full_name}
                />
              </div>
            </div>
            <hr />
            <div className="col-12 ml-0">
              <RestlessDisplayLarge
                label="Text"
                content={
                  row.body || (
                    <div className="text-muted">This posts has no text</div>
                  )
                }
              />
            </div>
            <div className="col-12">
              {row.gif_id && (
                <>
                  <h4 className="mb-4">Gif</h4>
                  <img
                    src={gifUrl}
                    alt=""
                    style={{
                      marginRight: "10px",
                      width: "200px",
                      height: "200px",
                      cursor: "pointer",
                    }}
                  />
                </>
              )}
            </div>

            <hr />
            <div className="row">
              <div className="col-12">
                <h4 className="mb-4">Interactions</h4>
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Reactions"
                  content={row.info?.reactions || 0}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Comments"
                  content={row.info?.comments || 0}
                />
              </div>
              <div className="col">
                <RestlessDisplayProperty
                  label="Reports"
                  content={row.reports || 0}
                />
              </div>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
